import Store from '@/store'
import resource from '@/resource'
import El from 'element-ui'

function requireAdminAuth(to, from, next) {

  global.Loading.begin("")
  Store.dispatch('session/check').then((r) => {
    global.Loading.end(); 
    console.log(r)
    if(r.auth && r.tipo == 1)
      next();
    else
      next({
        path: '/nao-permitido'
        //query: { redirect: to.fullPath }
      })
  }, () => {
    global.Loading.end(); 
    next({
      path: '/p/login'
    })
  })
}
function requireUserAuth(to, from, next) {

  global.Loading.begin("")
  Store.dispatch('session/check').then((r) => {
    global.Loading.end(); 
    console.log(r)
    if(r.auth && r.tipo == 2)
      next();
    else
      next({
        path: '/nao-permitido'
        //query: { redirect: to.fullPath }
      })
  }, () => {
    global.Loading.end(); 
    next({
      path: '/p/login'
    })
  })
}
function requireAuth(to, from, next) {

  global.Loading.begin("")
  Store.dispatch('session/check').then((r) => {
    global.Loading.end(); 
    console.log(r)
    if(r.auth)
      next();
    else
      next({
        path: '/p/login'
        //query: { redirect: to.fullPath }
      })
  }, () => {
    global.Loading.end(); 
    next({
      path: '/p/login'
    })
  })
}
function requireLogout(to, from, next) {

  global.Loading.begin("Saindo...")
  Store.dispatch('session/logout').then((r) => {
    global.Loading.end(); 
    console.log(r)
      next({
        path: '/'
      })
  }, () => {
    global.Loading.end(); 
      next({
        path: '/'
      })
  })
}
function requireProdutorAuth(to, from, next) {

  Store.dispatch('session/isAuthed').then((r) => {
    if (r.user.type == 3)
      next();
    else
      next({
        path: '/nao-permitido'
        //query: { redirect: to.fullPath }
      })
  }, () => {
    //not logged redirect to login
    next({
      path: '/p/login'
      //query: { redirect: to.fullPath }
    })
  })

}


function checkAuth(to, from, next) {
  Store.dispatch('session/check').then((r) => {
  }, () => {
  });
  next();
}
function requireUnauth(to, from, next) {
  global.Loading.begin("")
  Store.dispatch('session/check').then((r) => {
    global.Loading.end();  
    
    next({
      path: '/'
    })
  }, () => {
    global.Loading.end(); 
    next();

  })

}
function activateRegister(to, from, next) {
  resource.get({
    url: `/session/activate/${to.params.token}`, 
    msg: "Ativando seu cadastro.",
    params: {
    }
  },res => { 
    El.MessageBox({
      title: "Cadastro ativado com sucesso",
      message: "<p>Seu cadastro está ativado! Você já pode fazer o login! </p><p>Estamos lhe redirecionando para a página de login.</p>",
      dangerouslyUseHTMLString: true,
      showCancelButton: false,
      confirmButtonText: 'Certo',
      type: 'success',
      callback: action => {
        next({
          path: '/p/login'
        })
      }
    })
  }, error => {
    El.MessageBox({
      title: "Erro ao ativar o cadastro!",
      message: "<p>Não foi possível ativar o seu cadastro. </p><p>Entre em contato com o suporte@espacowinnicottbsb.com.br </p>",
      dangerouslyUseHTMLString: true,
      showCancelButton: false,
      confirmButtonText: 'Certo',
      type: 'error',
      callback: action => {
        next({
          path: '/p/cadastro-nao-ativado'
        })
      }
    })
  });
}
function updateAuth(to, from, next) {

  Store.dispatch('session/isAuthed').then(() => {
    next();


  }, () => {
    next();
  })

}

function logout(to, from, next) {
  Store.dispatch('session/logout').then(() => {
    next({
      path: '/p/login'
    })
  }, () => {

  });

}
function activate(to, from, next) {
  Store.dispatch('session/activateAccount', {token: to.query.signature}).then(() => {
      next({
        path: '/p/login'
      })
    }, () => {
      next({
        path: '/p/login'
      })
    });

}

export {
  requireAdminAuth,
  requireUserAuth,
  requireHomeAuth,
  requireUnauth,
  requireAuth,
  activateRegister,
  requireLogout,
  updateAuth,
  checkAuth,
  activate,
  logout
}